import { useParams } from "react-router-dom";

function useFetcherHashKey() {
  const { id, type: formType } = useParams();
  const hash = formType && id ? formType + "#" + id : formType || "";

  return hash;
}

export default useFetcherHashKey;
